import { ref, watch } from 'vue'

const popupOpen = ref(false)

export const usePopup = () => {
    const popup = ref(null)

    watch(popup, (popup) => {
        if (popup) {
            if (Array.isArray(popup)) {
                popup[0].focus()
            } else {
                popup.focus()
            }
        }
    })
    function togglePopup(e) {
        e.preventDefault()
        popupOpen.value = !popupOpen.value
    }

    return {
        popup,
        popupOpen,

        togglePopup
    }
}
